// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_swiper_modules_effect-fade_css-node_modules_swiper_swiper_css-node_modul-5558d8"], function() { return __webpack_require__("./assets/js/src/slider.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
